import { FC, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getIsAuth, getIsAuthPending } from 'redux/reducers/auth/selectors';
import { useNavigate } from 'react-router';
import { EASSpinner } from 'components/EASSpinner';
import { IS_NEMAN } from 'services/constants/env';
import { authManager } from 'services/auth';
import { DEFAULT_AUTHORIZED_PATH, PATHS } from 'routes/constants';

export const HomePage: FC = () => {
	const navigate = useNavigate();
	const ifAuth = useSelector(getIsAuth);
	const isPending = useSelector(getIsAuthPending);

	useEffect(() => {
		if (new URLSearchParams(window.location.search).has('code')) {
			navigate(`${PATHS.AUTH_CODE_PAGE}${window.location.search}`, { replace: true });
			return;
		}

		if (isPending) return;

		if (ifAuth) {
			navigate(DEFAULT_AUTHORIZED_PATH, { replace: true });
			return;
		}

		if (IS_NEMAN || authManager.isSignedOut()) {
			navigate('/login', { replace: true });
			return;
		}

		void authManager.loginRedirect(DEFAULT_AUTHORIZED_PATH);
	}, [ifAuth, isPending, navigate]);

	return <EASSpinner />;
};
